<!--用户统计[代理商用户活跃榜:某个时间段新增的用户数]-->
<template>
    <viewTable
        ref="viewTableRef"
    />
</template>

<script>
import viewTable from "./template/viewTable";
export default {
    name: "user",
    components:{
        viewTable
    },
    data(){
        return {
            lang:this.$lang.getLang('agentStatistics','agentNum'),
        }
    },
    methods:{

    },
    mounted() {
        this.$refs.viewTableRef.init('agentReport.report/getAgentNumReport');
        // this.$refs.viewTableRef.explain = '用于统计某个时间段下一级新增的代理商数量';
        this.$refs.viewTableRef.explain = this.lang['explain'];
    }
}
</script>

<style scoped>

</style>